<script>
import ErrorAlert from "@/components/errorAlert";
import Layout from "../../layouts/main";
import axios from "axios";
import ShowPasswordModal from '@/components/showPasswordModal.vue';
import { toast, variants } from "@/helpers/toaster";

/**
 * Form Layouts component
 */
export default {
  page: {
    title: "Nova firma",
  },
  components: {ErrorAlert, Layout, ShowPasswordModal},
  methods: {
    async submitForm() {
      this.$store.commit('loader/START_LOADING');

      try {
        const req = {
          partner_id: this.partner_id,
          partner_name: this.company_name,
          company_id: this.company_id,
          company_name: this.company_name,
          name: this.company_name,
          email: this.email,
          show_prices_to_employees: this.show_prices_to_employees,
          show_codes_to_employees: this.show_codes_to_employees,
          show_ids_to_employees: this.show_ids_to_employees,
          show_limit_to_employees: this.show_limit_to_employees,
          show_rebate_to_employees: this.show_rebate_to_employees,
          show_price_with_rebate_to_employees: this.show_price_with_rebate_to_employees,
          show_package_to_employees: this.show_number_in_package_to_employees,
          show_jm_to_employees: this.show_jm_to_employees,
          narudzbenica_include_group: this.narudzbenica_include_group,
          narudzbenica_include_object_code: this.narudzbenica_include_object_code,
          narudzbenica_include_object_name: this.narudzbenica_include_object_name,
          pricelists: [this.pricelist],
          registrator: this.registrator,
          warehouse: this.warehouse,
          classification_domain_app: this.classification_domain_app,
          classification_domain_ariba: this.classification_domain_ariba,
        }
        
        if (this.rebate && this.rebate !== '') req['rebate'] = this.rebate;

        const response = await axios.post('/super-admin/administrators', req);
        toast('Uspešno kreiranje firme.', variants.SUCCESS)

        this.password = response.data.plain_password;
        this.showModal = true;
      } catch (e) {
        // eslint-disable-next-line no-empty
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    cancel() {
      this.$router.push(`/super-admin/administrators`)
    },
    close() {
      this.showModal = false;
      this.cancel();
    }
  },
  data() {
    return {
      showModal: false,
      password: '',
      partner_id: '',
      partner_name: '',
      company_id: '',
      company_name: '',
      registrator: '',
      warehouse: '',
      name: '',
      email: '',
      rebate: null,
      show_prices_to_employees: false,
      show_codes_to_employees: false,
      show_ids_to_employees: false,
      show_rebate_to_employees: false,
      show_price_with_rebate_to_employees: false,
      show_limit_to_employees: false,
      show_number_in_package_to_employees: false,
      show_jm_to_employees: false,
      narudzbenica_include_object_name: false,
      narudzbenica_include_object_code: false,
      narudzbenica_include_group: false,
      pricelist: '',
      classification_domain_app: '',
      classification_domain_ariba: '',
    };
  },
};
</script>

<template>
  <Layout>
    <show-password-modal title="Uspešno kreiranje firme" :password="password" :showModal="showModal" @closed="close"/>
    <div>
      <ErrorAlert></ErrorAlert>

      <b-form @submit.prevent="submitForm()">
        
        <div class="row">
          <div class="offset-3 col-md-6">
            <div class="form-group">
              <label>
                Id partnera
              </label>
              <b-form-input v-model="partner_id"  id="administrator-partner-id-input" type="text"></b-form-input>
            </div>

            <div class="form-group">
              <label>
                PIB
              </label>
              <b-form-input v-model="company_id"  id="administrator-company-id-input" type="text"></b-form-input>
            </div>

            <div class="form-group">
              <label>
                Naziv firme
              </label>
              <b-form-input v-model="company_name"  id="administrator-company-name-input" type="text"></b-form-input>
            </div>

            <div class="form-group">
              <label>
                Magacin
              </label>
              <b-form-input v-model="warehouse" id="administrator-warehouse-input" type="text"></b-form-input>
            </div>
            
            <div class="form-group">
              <label>
                Registrator
              </label>
              <b-form-input v-model="registrator" id="administrator-registrator-input" type="text"></b-form-input>
            </div>

            <div class="form-group">
              <label>
                Rabat (%):
              </label>
              <b-form-input v-model="rebate" placeholder="" 
                            id="administrator-limit-input" type="number" :max="100" :min="0"></b-form-input>
            </div>

            <div class="form-group">
              <label>
                Email
              </label>
              <b-form-input v-model="email" placeholder="" 
                            id="administrator-name-input" type="text"></b-form-input>
            </div>
            <div class="form-group">
              <label>
                Cenovnik
              </label>
              <b-form-input v-model="pricelist" placeholder="" 
                            id="pricelist-name-input" type="text"></b-form-input>
            </div>
            <div class="form-group">
                <b-form-checkbox
                        v-model="show_prices_to_employees"
                        :value="true"
                        :unchecked-value="false"
                >
                    Prikaži cenu objektima
                </b-form-checkbox>
            </div>
            <div class="form-group">
                <b-form-checkbox
                        v-model="show_codes_to_employees"
                        :value="true"
                        :unchecked-value="false"
                >
                    Prikaži šifru objektima
                </b-form-checkbox>
            </div>
            <div class="form-group">
                <b-form-checkbox
                        v-model="show_ids_to_employees"
                        :value="true"
                        :unchecked-value="false"
                >
                    Prikaži id objektima
                </b-form-checkbox>
            </div>
            <div class="form-group">
                <b-form-checkbox
                        v-model="show_limit_to_employees"
                        :value="true"
                        :unchecked-value="false"
                >
                    Prikaži limit objektima
                </b-form-checkbox>
            </div>
            <div class="form-group">
                <b-form-checkbox
                        v-model="show_price_with_rebate_to_employees"
                        :value="true"
                        :unchecked-value="false"
                >
                    Prikaži cenu sa rabatom objektima
                </b-form-checkbox>
            </div>
            <div class="form-group">
                <b-form-checkbox
                        v-model="show_rebate_to_employees"
                        :value="true"
                        :unchecked-value="false"
                >
                    Prikaži rabat objektima
                </b-form-checkbox>
            </div>
            <div class="form-group">
              <b-form-checkbox
                      v-model="show_number_in_package_to_employees"
                      :value="true"
                      :unchecked-value="false"
              >
                  Prikaži broj komada u pakovanju objektima
              </b-form-checkbox>
          </div>
            <div class="form-group">
              <b-form-checkbox
                  v-model="show_jm_to_employees"
                  :value="true"
                  :unchecked-value="false"
              >
                Prikaži jedinicu mere objektima
              </b-form-checkbox>
            </div>
            <div class="form-group">
              <b-form-checkbox
                  v-model="narudzbenica_include_group"
                  :value="true"
                  :unchecked-value="false"
              >
                Prikaži ime grupe u polju "narudžbenica"
              </b-form-checkbox>
            </div>
            <div class="form-group">
              <b-form-checkbox
                  v-model="narudzbenica_include_object_code"
                  :value="true"
                  :unchecked-value="false"
              >
                Prikaži šifru objekta u polju "narudžbenica"
              </b-form-checkbox>
            </div>
            <div class="form-group">
              <b-form-checkbox
                  v-model="narudzbenica_include_object_name"
                  :value="true"
                  :unchecked-value="false"
              >
                Prikaži ime objekta u polju "narudžbenica"
              </b-form-checkbox>
            </div>

            <hr class="my-4" />
            <h5 class="mb-3">Ariba klasifikacija</h5>

            <div class="form-group">
              <label>
                Klasifikacioni domen (APP, max 3)
              </label>
              <b-form-input
                v-model="classification_domain_app"
                maxlength="3"
                placeholder="npr. C1"
                id="classification-domain-app-input"
                type="text"
              ></b-form-input>
            </div>
            <div class="form-group">
              <label>
                Klasifikacioni domen (Ariba)
              </label>
              <b-form-input
                v-model="classification_domain_ariba"
                maxlength="50"
                placeholder="npr. CUSTOM"
                id="classification-domain-ariba-input"
                type="text"
              ></b-form-input>
            </div>

            <div class="text-right">
              <b-button type="button" variant="secondary" @click="cancel()">Otkaži</b-button>
              <b-button type="submit" variant="primary" class="ml-2" >Snimi</b-button>
            </div>
          </div>
        </div>
      </b-form>
    </div>
  </Layout>
</template>
<style scoped>

input[type='radio'] {
  display: none;
}

.button {
  display: inline-block;
  position: relative;
  width: 50px;
  height: 50px;
  margin: 10px;
  cursor: pointer;
}

.button span {
  position: absolute;
  width: 50px;
  height: 50px;
  padding: 0;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  border-radius: 100%;
  background: #eeeeee;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
  transition: ease .3s;

  display: flex; /* or inline-flex */
  align-items: center;
  justify-content: center;

  color: white;
  font-size: 24px
}

.button span:hover {
  padding: 10px;
}

.orange .button span {
  background: #FF5722;
}

.pink .button span {
  background: #e067ea;
}

.yellow .button span {
  background: #faf15d;
}

.amber .button span {
  background: #FFC107;
}

.lime .button span {
  background: #8BC34A;
}

.teal .button span {
  background: #009688;
}

.blue .button span {
  background: #2196F3;
}

.indigo .button span {
  background: #3F51B5;
}

</style>
